import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { Select as SelectAnt } from "antd";
import {
    Grid,
    InputLabel,
    Select,
    MenuItem,
    FormControl,
    Stack,
    OutlinedInput,
    Button,
} from "@mui/material";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 480,
    backgroundColor: "white",
    boxShadow: 24,
    maxHeight: 500,
    overflowY: "hidden",
    overflowX: "hidden",
    border: "none",
    p: 2,
};

const Modals = ({ open }) => {
    let loginDetailsLocalStorage = localStorage.getItem("userData");
    let loginDetails = JSON.parse(loginDetailsLocalStorage);
    const selectedTeamId = localStorage.getItem("teams_id");

    const HandleTeamChanged = (value) => {
        localStorage.setItem("teams_id", value);
        window.location.reload();
    };

    // Auto reload jab ek team ho aur abhi tak team select nahi hui
    useEffect(() => {
        if (loginDetails?.teams?.length === 1 && !selectedTeamId) {
            localStorage.setItem("teams_id", loginDetails?.teams[0]?.id);
            window.location.reload();
        }
    }, [loginDetails?.teams, selectedTeamId]);

    return (
        <Modal
            keepMounted
            open={open}
            aria-labelledby="keep-mounted-modal-title"
            aria-describedby="keep-mounted-modal-description"
        >
            <Box sx={style}>
                <h4 style={{ textAlign: "center", marginTop: "20px" }}>
                    Please Select a Team
                </h4>
                <div style={{}}>
                    <Stack>
                        <FormControl variant="outlined" fullWidth></FormControl>
                    </Stack>

                    <Select
                        onChange={(e) => HandleTeamChanged(e.target.value)}
                        value={loginDetails?.teams?.length === 1 ? loginDetails?.teams[0]?.id : selectedTeamId || ''}
                        sx={{
                            width: "240px",
                            display: "flex",
                            justifyContent: "center",
                            margin: "auto",
                            marginTop: "30px",
                            marginBottom: "30px",
                        }}
                    >
                        {Array.isArray(loginDetails?.teams) && loginDetails?.teams?.length !== 0 &&
                            loginDetails?.teams?.map((e, i) => (
                                <MenuItem key={e?.id} value={e?.id}>
                                    {e?.name}
                                </MenuItem>
                            ))}
                    </Select>
                </div>
            </Box>
        </Modal>
    );
};

export default Modals;